import { i18n } from "@/plugins/i18n.ts";
import router from "@/_helpers/router.ts";
import { useSnackbarStore } from "@/_store/snackbar.module.ts";
import { RouteName } from "@/constants/routes.ts";

/**
 * Displays the "Export to CSV in progress" snackbar after an MSP CSV export is started.
 * Behavior differs by context:
 * - Global context: generic success message pointing to Activity Logs (no redirection).
 * - MSP context: success message pointing to Exports, with a "View" button opening
 *   the Reports Exports tab, where the started export is listed.
 * @param isGlobalContext - True when the export runs in the Global Admin context.
 */
export const showMspExportStartedToast = (isGlobalContext = false) => {
  const snackbarStore = useSnackbarStore();

  if (isGlobalContext) {
    snackbarStore.addGenericSuccess(
      i18n.global.t("snackbar.messages.general.exportCsvStarted", {
        pageName: i18n.global.t("activityLogs.title"),
      })
    );
    return;
  }

  snackbarStore.addSuccessWithCallbackBtn({
    html: i18n.global.t("snackbar.messages.general.exportCsvStarted", {
      pageName: i18n.global.t("reports.tabs.exports"),
    }),
    callback: async () => {
      await router.push({ name: RouteName.MSP_REPORTS_EXPORTS_TAB });
    },
    callbackName: i18n.global.t("general.view"),
  });
};
